import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import { getStore } from '../store/store';

// Same as owa-folders-constants/src/index.ts
// Used here to avoid circular dependency between owa-session-store and owa-folders-constants and shared and non-shared packages
export const UNIFIED_INBOX_FOLDER_NAME_PREFIX: string = 'UnifiedInbox:';

export default function folderIdToName(
    folderId: string,
    shouldSearchShared?: boolean
): DistinguishedFolderIdName {
    const store = getStore();

    if (!folderId) {
        return 'none';
    }

    // Handle Unified Inbox folder names since they are prefixed
    // So try to extract the actual DistinguishedFolderIdName out of it
    if (folderId.indexOf(UNIFIED_INBOX_FOLDER_NAME_PREFIX) === 0) {
        return folderId.substring(
            UNIFIED_INBOX_FOLDER_NAME_PREFIX.length
        ) as DistinguishedFolderIdName;
    }

    if (shouldSearchShared) {
        let folderName = store.defaultFolderIdToNameMap?.get(folderId);
        if (!folderName) {
            folderName = store.sharedMailboxFolderIdToNameMap?.get(folderId);
        }
        return folderName || 'none';
    } else {
        return store.defaultFolderIdToNameMap?.get(folderId) || 'none';
    }
}
